export enum ListViewType {
  List = 1,
  FullScreen = 2,
}
